import { html } from "react-strict-dom";

import * as svg from "react-native-svg";

const out: Record<string, any> = {
  a: html.a,
  article: html.article,
  aside: html.aside,
  b: html.b,
  blockquote: html.blockquote,
  button: html.button,
  code: html.code,
  div: html.div,
  em: html.em,
  fieldset: html.fieldset,
  footer: html.footer,
  form: html.form,
  h1: html.h1,
  h2: html.h2,
  h3: html.h3,
  h4: html.h4,
  h5: html.h5,
  h6: html.h6,
  header: html.header,
  hr: html.hr,
  i: html.i,
  img: html.img,
  input: html.input,
  label: html.label,
  li: html.li,
  main: html.main,
  mark: html.mark,
  nav: html.nav,
  ol: html.ol,
  optgroup: html.optgroup,
  option: html.option,
  p: html.p,
  pre: html.pre,
  section: html.section,
  select: html.select,
  span: html.span,
  strong: html.strong,
  sub: html.sub,
  sup: html.sup,
  textarea: html.textarea,
  u: html.u,
  ul: html.ul,

  // svg
  svg: svg.Svg,
  path: svg.Path,
  rect: svg.Rect,
  circle: svg.Circle,
  ellipse: svg.Ellipse,
  line: svg.Line,
  polyline: svg.Polyline,
  polygon: svg.Polygon,
  defs: svg.Defs,
  linearGradient: svg.LinearGradient,
  radialGradient: svg.RadialGradient,
  stop: svg.Stop,
  use: svg.Use,
  text: svg.Text,
  tspan: svg.TSpan,
  g: svg.G,
  svgUri: svg.SvgUri,

  // filters
  feBlend: svg.FeBlend,
  feColorMatrix: svg.FeColorMatrix,
  feComponentTransfer: svg.FeComponentTransfer,
  feComposite: svg.FeComposite,
  feConvolveMatrix: svg.FeConvolveMatrix,
  feDiffuseLighting: svg.FeDiffuseLighting,
  feDisplacementMap: svg.FeDisplacementMap,
  feDropShadow: svg.FeDropShadow,
  feFlood: svg.FeFlood,
  feGaussianBlur: svg.FeGaussianBlur,
  feMerge: svg.FeMerge,
  feMergeNode: svg.FeMergeNode,
  feMorphology: svg.FeMorphology,
  feOffset: svg.FeOffset,
  feSpecularLighting: svg.FeSpecularLighting,
  feTile: svg.FeTile,
  feTurbulence: svg.FeTurbulence,
  feDistantLight: svg.FeDistantLight,
  fePointLight: svg.FePointLight,
  feSpotLight: svg.FeSpotLight,
  image: svg.Image,
};

export default out;
